import React from "react";
import "./Page.css";
import useStore from "../store.js";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { useParams } from "react-router-dom";

import Button from "../components/Button/Button.js";

import { getFirstName } from "../util/methods.js";
import { useNavigateWithVars } from "../hooks/useNavigateWithVars";

const Page = (props) => {
  const getLocalized = useStore((state) => state.getLocalized);
  const game = useStore((state) => state.game);
  const setGameState = useStore((state) => state.setGameState);
  const isHost = useStore((state) => state.isHost);
  const gameState = useStore((state) => state.gameState);
  const character = useStore((state) => state.character);
  const defaultCharacter = useStore((state) => state.defaultCharacter);
  const defaultGame = useStore((state) => state.defaultGame);
  const hasPopupBild = useStore((state) => state.hasPopupBild);

  // const openHint = useStore((state) => state.openHint);
  const currentHint = useStore((state) => state.currentHint);
  const revealNextHint = useStore((state) => state.revealNextHint);
  const navigateTo = useNavigateWithVars();

  const { roundid } = useParams();

  console.log("Round Page", roundid, character, game, currentHint, gameState);

  if (!game) return null;
  return (
    <div
      className={`Page${props.className ? " " + props.className : ""}${hasPopupBild ? " withPopupButton" : ""}`}
    >
      <h1>{getLocalized("texts", "Runde") + " " + roundid}</h1>
      <div className="Times">
        {character?.Times?.map((timeEntry, index) => {
          //console.log("Time Entry", timeEntry);
          if (timeEntry?.Round != roundid) return null;
          //console.log("Time Entry", timeEntry);
          return (
            <div className="TimeEntry" key={index}>
              <strong>{timeEntry?.Headline}</strong>
              {timeEntry?.Text && <BlocksRenderer content={timeEntry?.Text} />}
            </div>
          );
        })}
      </div>
      {gameState <= game?.Rounds && (
        <div className="nextSteps">
          {gameState === 1 && currentHint < 0 && (
            <>
              <BlocksRenderer
                content={getLocalized("texts", "TextVorstellungsrunde")}
              />
              {getLocalized("game", "Characters")?.data?.map((role, index) => {
                return (
                  <span key={index}>
                    {index + 1}. {getFirstName(role.attributes.Name)}
                    {index < getLocalized("game", "Characters").data.length - 1
                      ? ", "
                      : ""}
                  </span>
                );
              })}
              <BlocksRenderer content={getLocalized("texts", "BeginntMit")} />
              {`(${getLocalized("texts", "ZuOeffnenVon")} ${
                getLocalized("game", "Hints")[0]?.Character?.data?.attributes
                  ?.Name
              })`}
            </>
          )}
          {currentHint > -1 &&
          currentHint < getLocalized("game", "Hints").length ? (
            // Check if next hint exists and is in a different round (= current hint is last of this round)
            getLocalized("game", "Hints")?.[currentHint + 1]?.Round !==
              gameState &&
            getLocalized("game", "Hints")?.[currentHint]?.WeiterText ? (
              // Show WeiterText from the CURRENT hint (last hint of round)
              <BlocksRenderer
                content={
                  getLocalized("game", "Hints")?.[currentHint]?.WeiterText
                }
              />
            ) : (
              // Show default text to continue with next hint in same round
              <>
                {currentHint >= 0 && (
                  <>
                    {(() => {
                      // Check if the next hint (currentHint + 1) is the first hint of the current round
                      const nextHint = getLocalized("game", "Hints")[
                        currentHint + 1
                      ];
                      const isFirstHintOfRound =
                        currentHint === -1 ||
                        nextHint?.Round !==
                          getLocalized("game", "Hints")[currentHint]?.Round;

                      return (
                        <BlocksRenderer
                          content={getLocalized(
                            "texts",
                            isFirstHintOfRound
                              ? "RoundStartWeiterText"
                              : "DefaultWeiterText",
                          )}
                        />
                      );
                    })()}
                    {defaultGame?.Hints?.[currentHint + 1]?.Character?.data
                      ?.attributes?.uid !== character?.uid && (
                      <>
                        <b>{`${getLocalized("texts", "Hinweis")} ${currentHint + 2}`}</b>
                        <br />
                      </>
                    )}
                  </>
                )}
              </>
            )
          ) : null}

          {}
          {currentHint > -1 &&
            currentHint < getLocalized("game", "Hints").length - 1 &&
            getLocalized("game", "Hints")?.[currentHint + 1]?.Round ===
              gameState &&
            defaultGame?.Hints?.[currentHint + 1]?.Character?.data?.attributes
              ?.uid !== character?.uid && (
              <>
                (
                {`${getLocalized("texts", "ZuOeffnenVon")} ${
                  defaultGame?.Hints?.[currentHint + 1]?.Character?.data
                    ?.attributes?.Name
                }`}
                )
              </>
            )}

          {getLocalized("game", "Hints").length > currentHint + 1 &&
            defaultGame?.Hints?.[currentHint + 1].Character?.data?.attributes
              .uid === defaultCharacter?.uid &&
            getLocalized("game", "Hints")[currentHint + 1]?.Round <=
              gameState && (
              <>
                <Button
                  onClick={() => {
                    revealNextHint();
                    navigateTo(`/hint/${currentHint + 2}`);
                  }}
                >
                  <strong>{`${getLocalized("texts", "Hinweis")} ${
                    currentHint + 2
                  }`}</strong>
                </Button>
              </>
            )}
          {isHost &&
            getLocalized("game", "Hints")[currentHint + 1]?.Round >
              gameState && (
              <Button onClick={() => setGameState(gameState + 1)}>
                <strong>{getLocalized("texts", "StartNextRound")}</strong>
              </Button>
            )}

          {isHost &&
            roundid == game?.Rounds &&
            currentHint >= getLocalized("game", "Hints").length - 1 && (
              <Button
                onClick={() => {
                  if (gameState <= game?.Rounds) setGameState(gameState + 1);
                  else navigateTo(`/reveal/`);
                }}
              >
                <strong>{getLocalized("texts", "Aufloesung")}</strong>
              </Button>
            )}
        </div>
      )}

      {props.children}
    </div>
  );
};

export default Page;
